import type { RoomPrivateView, RoomPublicView, StoredView } from './views';

export function encodeView(view: { version: number }): StoredView {
  return { v: view.version, data: JSON.stringify(view) };
}

function isStoredView(raw: unknown): raw is StoredView {
  return (
    typeof raw === 'object' &&
    raw !== null &&
    typeof (raw as StoredView).v === 'number' &&
    typeof (raw as StoredView).data === 'string'
  );
}

export function decodeView<T extends { version: number }>(raw: unknown): T | null {
  if (!isStoredView(raw)) return null;
  const parsed = JSON.parse(raw.data) as T;
  if (parsed.version !== raw.v)
    throw new Error(`View version mismatch ${parsed.version} != ${raw.v}`);
  return parsed;
}

export const decodePublicView = (raw: unknown) => decodeView<RoomPublicView>(raw);
export const decodePrivateView = (raw: unknown) => decodeView<RoomPrivateView>(raw);
